;(function (window, document) {
    console.log('language-selector loaded');

    document.addEventListener("DOMContentLoaded", function () {
        const wrapper = document.getElementById("language-selector");
        if (!wrapper) return;

        const cur = wrapper.dataset.currentLanguage;
        window.initI18n(cur).catch(console.error);

        const startBtn = wrapper.querySelector(`.flag-btn[value="${cur}"]`);
        if (startBtn) startBtn.classList.add("active");

        wrapper.addEventListener("click", function (e) {
            const btn = e.target.closest(".flag-btn");
            if (!btn || !wrapper.contains(btn)) return;

            wrapper.querySelectorAll(".flag-btn").forEach(b => b.classList.remove("active"));
            btn.classList.add("active");

            const lang = btn.value;
            window.changeLanguageJS(lang).catch(console.error);
            fetch("/action/language-selection", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ language: lang })
            })
                .then(res => {
                    if (res.ok) {
                        location.reload();
                    } else {
                        return res.json().then(data => {
                            alert(data.message || "Serverfeil – prøv igjen");
                        });
                    }
                })
                .catch(err => {
                    console.error("Fetch error:", err);
                    alert("Kunne ikke endre språk – sjekk nettverk.");
                });
        });
    });

})(window, document);
